import React from 'react';
import { Button, Group, Paper, Text } from '@mantine/core';
import { IconUserPlus, IconX } from '@tabler/icons-react';

export interface AssignBulkSelectionBarProps {
  selectedCount: number;
  onClear: () => void;
  onAssignUsers?: () => void;
  assignUsersLabel?: string;
}

/** Toolbar strip shown when Gantt assign checkboxes have a selection. */
export function AssignBulkSelectionBar({
  selectedCount,
  onClear,
  onAssignUsers,
  assignUsersLabel = 'Assign users',
}: AssignBulkSelectionBarProps) {
  if (selectedCount <= 0) return null;

  return (
    <Paper
      withBorder
      radius="md"
      px="sm"
      py={5}
      style={{
        flexShrink: 0,
        borderColor:
          'color-mix(in srgb, var(--mantine-color-brand-6) 35%, var(--mantine-color-default-border))',
        background:
          'color-mix(in srgb, var(--mantine-color-brand-6) 8%, var(--mantine-color-body))',
      }}
    >
      <Group justify="space-between" wrap="nowrap" gap="xs">
        <Text size="xs" fw={600} c="dimmed">
          {selectedCount.toLocaleString()} selected
        </Text>
        <Group gap={6} wrap="nowrap">
          {onAssignUsers ? (
            <Button
              size="compact-xs"
              variant="filled"
              color="brand"
              leftSection={<IconUserPlus size={12} stroke={1.75} />}
              onClick={onAssignUsers}
            >
              {assignUsersLabel}
            </Button>
          ) : null}
          <Button
            size="compact-xs"
            variant="subtle"
            color="gray"
            leftSection={<IconX size={12} stroke={1.75} />}
            onClick={onClear}
          >
            Clear
          </Button>
        </Group>
      </Group>
    </Paper>
  );
}
